import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pveTab", "pvpTab", "pvePanel", "pvpPanel"]

  showPve() {
    this.pvePanelTarget.classList.remove("hidden")
    this.pvpPanelTarget.classList.add("hidden")
    this.pveTabTarget.classList.add("text-amber-400", "border-b-2", "border-amber-500")
    this.pveTabTarget.classList.remove("text-[#9ca3af]", "hover:text-[#e5e5e5]")
    this.pvpTabTarget.classList.remove("text-amber-400", "border-b-2", "border-amber-500")
    this.pvpTabTarget.classList.add("text-[#9ca3af]", "hover:text-[#e5e5e5]")
  }

  showPvp() {
    this.pvpPanelTarget.classList.remove("hidden")
    this.pvePanelTarget.classList.add("hidden")
    this.pvpTabTarget.classList.add("text-amber-400", "border-b-2", "border-amber-500")
    this.pvpTabTarget.classList.remove("text-[#9ca3af]", "hover:text-[#e5e5e5]")
    this.pveTabTarget.classList.remove("text-amber-400", "border-b-2", "border-amber-500")
    this.pveTabTarget.classList.add("text-[#9ca3af]", "hover:text-[#e5e5e5]")
  }
}
